import { Share2Icon } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface CopyLinkButtonProps {
  copiedUrl: string
}

export const CopyLinkButton = ({ copiedUrl }: CopyLinkButtonProps) => {
  const handleClickCopyLinkButton = async () => {
    try {
      await navigator.clipboard.writeText(copiedUrl)
      toast.success('Link copied successfully!', {
        position: 'top-center',
      })
    } catch {
      toast.error('Copy failed.')
    }
  }

  return (
    <Button
      type="button"
      size="sm"
      className={cn('inline-flex gap-x-2', 'bg-sky-100 hover:bg-sky-200', 'text-foreground')}
      onClick={handleClickCopyLinkButton}
    >
      <Share2Icon size={16} />
      Copy Link
    </Button>
  )
}
